"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MultiSelectOption = void 0;
var react_1 = __importStar(require("react"));
var focus_1 = require("@react-aria/focus");
var listbox_1 = require("@react-aria/listbox");
var utils_1 = require("@react-aria/utils");
var classnames_1 = __importDefault(require("classnames"));
var uuid_1 = require("uuid");
var a11y_1 = require("@kaizen/a11y");
var component_library_1 = require("@kaizen/component-library");
var check_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/check.icon.svg"));
var draft_badge_1 = require("@kaizen/draft-badge");
var provider_1 = require("../../provider");
var MultiSelectOption_module_scss_1 = __importDefault(require("./MultiSelectOption.module.scss"));
var MultiSelectOption = function (_a) {
    var _b, _c, _d;
    var classNameOverride = _a.classNameOverride, item = _a.item;
    var state = (0, provider_1.useSelectionContext)().selectionState;
    // Get props for the option element
    var ref = react_1["default"].createRef();
    var _e = (0, listbox_1.useOption)({ key: item.key }, state, ref), optionProps = _e.optionProps, isSelected = _e.isSelected, isDisabled = _e.isDisabled;
    // Determine whether we should show a keyboard
    // focus ring for accessibility
    var _f = (0, focus_1.useFocusRing)(), isFocusVisible = _f.isFocusVisible, focusProps = _f.focusProps;
    var countElementId = (0, react_1.useMemo)(function () { return (0, uuid_1.v4)(); }, []);
    return (react_1["default"].createElement("li", __assign({}, (0, utils_1.mergeProps)(optionProps, focusProps), { ref: ref, className: (0, classnames_1["default"])(MultiSelectOption_module_scss_1["default"].option, classNameOverride, isSelected && MultiSelectOption_module_scss_1["default"].isSelected, isFocusVisible && MultiSelectOption_module_scss_1["default"].isFocusVisible, isDisabled && MultiSelectOption_module_scss_1["default"].isDisabled), "aria-label": (_b = item.value) === null || _b === void 0 ? void 0 : _b.label, "aria-describedby": ((_c = item.value) === null || _c === void 0 ? void 0 : _c.count) ? countElementId : undefined }),
        react_1["default"].createElement("span", { className: (0, classnames_1["default"])(MultiSelectOption_module_scss_1["default"].icon, isSelected && MultiSelectOption_module_scss_1["default"].isSelected) }, isSelected && react_1["default"].createElement(component_library_1.Icon, { icon: check_icon_svg_1["default"], role: "presentation" })),
        item.rendered,
        ((_d = item.value) === null || _d === void 0 ? void 0 : _d.count) && (react_1["default"].createElement("span", { id: countElementId, className: MultiSelectOption_module_scss_1["default"].badgeContainer },
            react_1["default"].createElement(draft_badge_1.Badge, { classNameOverride: MultiSelectOption_module_scss_1["default"].badge }, item.value.count),
            react_1["default"].createElement(a11y_1.VisuallyHidden, null, " available")))));
};
exports.MultiSelectOption = MultiSelectOption;
exports.MultiSelectOption.displayName = "MultiSelectOption";
//# sourceMappingURL=MultiSelectOption.js.map